import { ICON_TYPE } from "@/components/library/Icon";

/** Icon-style choices shared by every `iconType` select field across blocks. */
export const ICON_TYPE_OPTIONS = [
  { label: "Light", value: ICON_TYPE.LIGHT },
  { label: "Regular", value: ICON_TYPE.REGULAR },
  { label: "Solid", value: ICON_TYPE.SOLID },
  { label: "Brand", value: ICON_TYPE.BRAND },
  { label: "Duotone", value: ICON_TYPE.DUOTONE },
];

/** Section background choices shared by the marketing section blocks. */
export const SECTION_BACKGROUND_OPTIONS = [
  { label: "Transparent", value: "transparent" },
  { label: "Surface", value: "surface" },
  { label: "Voice card", value: "voiceCard" },
  { label: "Primary", value: "primary" },
  { label: "White", value: "white" },
];
